import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Catering from "@/pages/Catering";
import PrivateEvents from "@/pages/PrivateEvents";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/menu" element={<Menu />} />
                    <Route path="/catering" element={<Catering />} />
                    <Route path="/private-events" element={<PrivateEvents />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#1A1A1A",
                        color: "#F5E9D6",
                        border: "1px solid rgba(212,175,55,0.25)",
                        borderRadius: 2,
                    },
                }}
            />
        </div>
    );
}

export default App;
